/* "Worn by you" — the colour pills.

   Clicking a pill selects that variant on the page rather than navigating. It
   drives Horizon's variant picker directly (which owns the form, the URL and
   the section re-render) rather than duplicating that logic here.

   The prototype only talks outward: it never listens back, so the pill for the
   currently selected colour looks exactly like the others. Here the pills sync
   from hystride:variant too, so the active one is marked. */
(function () {
  'use strict';

  const H = window.Hystride;
  if (!H) return;

  H.register('worn-by-you', {
    mount(root) {
      const rails = H.initRails(root);
      const pills = Array.from(root.querySelectorAll('[data-worn-variant]'));

      const onClick = (e) => {
        const pill = e.currentTarget;
        const variantId = pill.dataset.wornVariant;
        const value = pill.dataset.optionValue;

        // Drive the real picker. Its own input is the single source of truth for
        // the form, the ?variant= parameter and the section re-render — so we
        // click it rather than reimplementing any of that.
        const picker = document.querySelector('variant-picker');
        let handled = false;

        if (picker) {
          const input = picker.querySelector(
            `input[value="${CSS.escape(value)}"], input[data-variant-id="${CSS.escape(variantId)}"]`
          );
          if (input) {
            input.click();
            handled = true;
          }
        }

        if (!handled) {
          // No picker on the page (or an option layout we do not recognise).
          // A normal navigation to the variant URL is the honest fallback —
          // better than a button that does nothing.
          window.location.search = `?variant=${variantId}`;
          return;
        }

        if (root.dataset.scrollToBuy === 'true') {
          const buy = document.querySelector('.pdp, [data-hys-buy-block]');
          buy?.scrollIntoView({
            behavior: H.reduceMotion() ? 'auto' : 'smooth',
            block: 'start',
          });
        }
      };

      const onVariant = (e) => {
        const id = String(e.detail?.id || '');
        pills.forEach((p) =>
          p.setAttribute('aria-current', p.dataset.wornVariant === id ? 'true' : 'false')
        );
      };

      pills.forEach((p) => p.addEventListener('click', onClick));
      document.addEventListener('hystride:variant', onVariant);

      return { rails, pills, onClick, onVariant };
    },

    unmount(root, s) {
      if (!s) return;
      s.rails.forEach((r) => r.destroy());
      s.pills.forEach((p) => p.removeEventListener('click', s.onClick));
      document.removeEventListener('hystride:variant', s.onVariant);
    },
  });
})();
